import get from 'lodash.get';
import { DEFAUL_USER_TYPE, INITIAL_USER_STATE } from '@/bootstrap/types';
import { handleErrors } from '@/helpers/index';
import AuthSerivce from '@/services/api/AuthService';
import UserService from '@/services/api/UserService';

export default {
  state: {
    user: INITIAL_USER_STATE,
    userInitialized: false,
  },

  mutations: {
    updateUser(state, updatedUser) {
      state.user = updatedUser;
      state.userInitialized = true;
      window.eventBus.$emit('userInitialized', updatedUser);
    },

    clearUserData(state) {
      state.user = INITIAL_USER_STATE;
    },
  },
  actions: {

    fetchUser({ commit, dispatch }) {
      AuthSerivce.me()
        .then(data => {
          const refreshToken = get(data, 'spotify_refresh_token.refresh_token', null);

          // If a refresh token exists, refresh users spotify access token
          if (refreshToken) {
            dispatch('refreshSpotifyUserAccessToken', data.spotify_refresh_token.refresh_token);
          }

          commit('updateUser', data);
        })
        .catch(handleErrors);
    },

    finishWizard({ commit, getters }) {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line camelcase
        UserService.update(getters.user.id, {
          has_finished_wizard: true,
          is_spotify_authorized: true,
        })
          .then(data => {
            commit('updateUser', data);
            resolve(data);
          })
          .catch(error => {
            handleErrors(error);
            reject(error);
          });
      });
    },

    updateSpotifyAuthorizationStatus({ commit, getters }, status) {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line camelcase
        UserService.update(getters.user.id, { is_spotify_authorized: status })
          .then(data => {
            commit('updateUser', data);
            resolve(data);
          })
          .catch(error => {
            handleErrors(error);
            reject(error);
          });
      });
    },

    updateUser({ commit, getters }, userData) {
      return new Promise((resolve, reject) => {
        UserService.update(getters.user.id, userData)
          .then(data => {
            commit('updateUser', data);
            resolve(data);
          })
          .catch(error => {
            handleErrors(error);
            reject(error);
          });
      });
    },
  },
  getters: {
    user(state) {
      return state.user;
    },

    hasFinishedWizard(state) {
      return get(state.user, 'has_finished_wizard', true);
    },

    isSpotifyAuthorized(state) {
      return get(state.user, 'is_spotify_authorized', true);
    },

    userInitialized(state) {
      return state.userInitialized;
    },

    userType(state) {
      return state.user.user_type;
    },

    isDefaultUser(state) {
      return state.user.user_type === DEFAUL_USER_TYPE;
    },

    permisisons(state) {
      return get(state.user, 'permissons', []);
    },
  },
};
